// src/pages/PrivacyPolicy.jsx
import React from "react";
import "./Privacy.css";

const Privacy = () => {
  return (
    <div className="privacy-page">
      <h1 className="privacy-main-heading">Privacy Policy</h1>

      <p className="privacy-intro">
        At ZA I INC. Inc., we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard data when you visit our website or interact with our services.
      </p>

      <section className="privacy-section">
        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>Contact details such as name, email, phone number via forms.</li>
          <li>Information automatically collected through cookies or analytics tools.</li>
          <li>Data you voluntarily provide when using our services.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To respond to inquiries and provide customer support.</li>
          <li>To improve our website, services, and offerings.</li>
          <li>For internal business analysis and operational purposes.</li>
          <li>To comply with legal and regulatory obligations.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>3. Data Sharing and Disclosure</h2>
        <p>
          We do not sell or rent your personal information. We may share data with:
        </p>
        <ul>
          <li>Service providers who assist with our operations (e.g., hosting, analytics).</li>
          <li>Legal authorities if required by law.</li>
          <li>Affiliates or business partners only for legitimate business purposes.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>4. Cookies and Tracking</h2>
        <p>
          Our website may use cookies and similar technologies to enhance user experience, analyze traffic, and improve performance. You can manage your cookie preferences through your browser settings.
        </p>
      </section>

      <section className="privacy-section">
        <h2>5. Security</h2>
        <p>
          We implement reasonable administrative, technical, and physical measures to protect your data from unauthorized access, disclosure, or misuse.
        </p>
      </section>

      <section className="privacy-section">
        <h2>6. Your Rights</h2>
        <p>
          You have the right to access, update, or delete your personal information. For any data requests, please contact us at <strong>fp@zainc.org</strong>.
        </p>
      </section>

      <section className="privacy-section">
        <h2>7. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. The latest version will always be posted on this page with an updated revision date.
        </p>
      </section>

      <p className="privacy-footer">
        ZA I INC. Inc. — Committed to Protecting Your Privacy and Ensuring Your Trust.
      </p>
    </div>
  );
};

export default Privacy;
